/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID, MetedataLinkDto, ProduceStatusDto } from '@gh/common-shared-data';
import { AbstractRestService, identity, optimisticLockingOf, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { EomReportDto } from './eom-reports.dto';
import { EomReportMapper } from './eom-reports.mapper';

@Injectable()
export class EomReportRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(): Observable<EomReportDto> {
    return this.httpGet(`${this.bp}/manager/eom`, optimisticLockingOf(EomReportMapper));
  }

  save(dto: EomReportDto): Observable<any> {
    return this.httpPut(`${this.bp}/manager/eom`, dto, optimisticLockingOf(EomReportMapper), identity());
  }

  getS3Link(id: ID): Observable<MetedataLinkDto> {
    return this.httpGet(`${this.bp}/manager/eom/complete-metadata/${id}`, identity());
  }

  getProduceStatus(id: ID): Observable<ProduceStatusDto> {
    return this.httpGet(`${this.bp}/manager/eom/produce-status/${id}`, void 0, void 0, identity());
  }

  validate(forYear: number, forMonth: number): Observable<any> {
    return this.httpPost(`${this.bp}/manager/eom/validate?forYear=${forYear}&forMonth=${forMonth}`, Object, identity());
  }
}
